import { useMutation } from 'react-query';

import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';

export async function generateCrossReferenceReport(
  orgId: string,
  accreditationBodyId: string,
  accreditationBodyVersionId: string,
): Promise<void> {
  const url = `${baseApiUrl()}/awb/accreditation-body/v1/organizations/${orgId}/reports/cross-reference/${accreditationBodyId}/versions/${accreditationBodyVersionId}`;
  await fetcher({ method: 'post', url });
}

export default function useGenerateCrossReferenceReport(
  onSuccess?: () => void,
  onError?: (error: ServerErrorResponse) => void,
) {
  return useMutation<
    void,
    ServerErrorResponse,
    {
      orgId: string;
      accreditationBodyId: string;
      accreditationBodyVersionId: string;
    }
  >(
    ({ orgId, accreditationBodyId, accreditationBodyVersionId }) =>
      generateCrossReferenceReport(orgId, accreditationBodyId, accreditationBodyVersionId),
    {
      onSuccess,
      onError,
    },
  );
}
